module.exports = __webpack_public_path__ + "img/user-journey.d4b4350d.png";